<!-- /**
 * @author Ketan Shetye
 * @created 2025-10-25
 */ -->

<span
  class="common-text"
  [ngClass]="data.fontFamily"
  [style.text-transform]="data.textTransform"
  [style.font-size]="data.fontSize ? data.fontSize : null"
  [style.font-weight]="data.fontWeight ? data.fontWeight : null"
  [style.color]="data.color ? data.color : null"
>
  <!-- Added by Amisha on 03-07-2026.
       Reason: render the text HTML and required marker as sibling elements so the shared required star can display correctly. -->
  <span class="common-text-content" [innerHTML]="data.text"></span>
  @if(data.required) {
    <span class="required-star">*</span>
  }
</span>
